import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import CollapsibleSection from './CollapsibleSection';

interface RulesDisplayProps {
  ruleset: 'WRC2025';
  modifications?: string[];
  startingPointValue?: 25000 | 30000;
}

const getRulesetInfo = (ruleset: 'WRC2025' | 'MahjongSoul') => {
  switch (ruleset) {
    case 'WRC2025':
      return {
        url: 'https://www.worldriichi.org/s/WRC-Rules-2025-42fx.pdf',
        displayName: 'WRC 2025',
        penaltiesLink: true,
      };
    case 'MahjongSoul':
      return {
        url: 'https://mahjongsoul.yo-star.com/faq',
        displayName: 'Mahjong Soul',
        penaltiesLink: false,
      };
    default:
      return {
        url: 'https://www.worldriichi.org/s/WRC-Rules-2025-42fx.pdf',
        displayName: 'WRC 2025',
        penaltiesLink: false,
      };
  }
};

const RulesDisplay: React.FC<RulesDisplayProps> = ({ ruleset, modifications = [], startingPointValue }) => {
  const rulesetInfo = getRulesetInfo(ruleset);

  return (
    <CollapsibleSection
      title="Rules"
      storageKey="rulesDisplayExpanded"
    >
      <div className="space-y-4">
        <div>
          <a
            href={rulesetInfo.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline font-medium"
          >
            {rulesetInfo.displayName}
          </a>
        </div>
        {rulesetInfo.penaltiesLink && (
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">Penalties Reference:</h3>
            <Link
              to="/penalties"
              className="inline-flex items-center text-blue-600 hover:text-blue-800 underline font-medium"
            >
              WRC Penalties 2025
              <ArrowTopRightOnSquareIcon className="h-4 w-4 ml-1" />
            </Link>
          </div>
        )}
        {startingPointValue && (
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">Starting Point Value:</h3>
            <p className="text-gray-700">{startingPointValue.toLocaleString()}</p>
          </div>
        )}
        {modifications.length > 0 && (
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">Tournament Modifications:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
              {modifications.map((modification, index) => (
                <li key={index}>{modification}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </CollapsibleSection>
  );
};

export default RulesDisplay;
